export default "__VITE_ASSET__DTfl1Bv5__"